import {useMultiStyleConfig} from '@chakra-ui/react';
import type {SystemStyleObject} from '@chakra-ui/styled-system';
import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

import type {GraphPart} from './anatomy';
import {anatomy, nodeAnatomy} from './anatomy';

export const {defineMultiStyleConfig: defineGraphStyleConfig, definePartsStyle: defineGraphPartsStyleConfig} =
  createMultiStyleConfigHelpers(anatomy);

export const {defineMultiStyleConfig: defineNodeStyleConfig, definePartsStyle: defineNodePartsStyleConfig} =
  createMultiStyleConfigHelpers(nodeAnatomy);

export const useGraphNodeStyleConfig = (
  args: Parameters<typeof useMultiStyleConfig>[1],
): Record<(typeof nodeAnatomy)[number], SystemStyleObject> => {
  return useMultiStyleConfig(`GraphNode`, args) ?? {};
};

export const useGraphStyleConfig = <P extends GraphPart>(
  part: P,
  props?: Parameters<typeof useMultiStyleConfig>[1],
) => {
  return useMultiStyleConfig(`Graph`, props ?? {})?.[part];
};

export const contentGroupedNodeSize = {
  width: 460,
  height: 400,
};

export const contentNodeSize = {
  width: 380,
  height: 100,
};

export const minimalNodeSize = {
  width: 100,
  height: 40,
};
